import Cookies from 'js-cookie'
import { getAuthRender } from '@/api/user'

const state = {
	sidebar: {
		opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
		withoutAnimation: false
	},
	device: 'desktop',
	size: Cookies.get('size') || 'small',
	login_sms_show: true,
	isFromOneLineWorkBench: false, // 是否来自一线工作台
	navbar: {
		opened: false
	}
}

const mutations = {
	TOGGLE_SIDEBAR: state => {
		state.sidebar.opened = !state.sidebar.opened
		state.sidebar.withoutAnimation = false
		if (state.sidebar.opened) {
			Cookies.set('sidebarStatus', 1)
		} else {
			Cookies.set('sidebarStatus', 0)
		}
	},
	CLOSE_SIDEBAR: (state, withoutAnimation) => {
		Cookies.set('sidebarStatus', 0)
		state.sidebar.opened = false
		state.sidebar.withoutAnimation = withoutAnimation
	},
	TOGGLE_DEVICE: (state, device) => {
		state.device = device
	},
	SET_SIZE: (state, size) => {
		state.size = size
		Cookies.set('size', size)
	},
	LOGIN_SMS_SHOW: (state, sms_show) => {
		state.login_sms_show = sms_show
	},
	IS_FROM_ONE_LINE_WORK_BENCH: (state, opened) => {
		state.isFromOneLineWorkBench = opened
	}
}

const actions = {
	toggleSideBar({ commit }) {
		commit('TOGGLE_SIDEBAR')
	},
	closeSideBar({ commit }, { withoutAnimation }) {
		commit('CLOSE_SIDEBAR', withoutAnimation)
	},
	toggleDevice({ commit }, device) {
		commit('TOGGLE_DEVICE', device)
	},
	setSize({ commit }, size) {
		commit('SET_SIZE', size)
	},
	async loginAuthRender({ commit }) {
		try {
			const { data = {} } = await getAuthRender()
			const { sms_show = true } = data
			commit('LOGIN_SMS_SHOW', sms_show)
		} catch (error) {
			console.error(error)
			commit('LOGIN_SMS_SHOW', true)
		}
	},
	toggleFromOneLineWorkBench({ commit }, payload) {
		commit('IS_FROM_ONE_LINE_WORK_BENCH', payload)
	}
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
